import React from 'react';

const FooterSection = () => {
  return (
    <footer className="hx-footer">
      <style>{`
        .hx-footer {
          background: #f9f5eeff;
          font-family: 'Raleway', sans-serif;
          color: #1e2330;
        }

        /* ================= TOP ================= */
        .hx-footer-top {
          max-width: 1400px;
          margin: 0 auto;
          padding: 48px 20px 36px;
          display: grid;
          grid-template-columns: 1.6fr repeat(4, 1fr);
          gap: 40px;
          align-items: start; /* 🔑 IMPORTANT FIX */
        }

        /* BRAND */
        .hx-brand h2 {
          font-size: 30px;
          font-weight: 800;
          color: #c62828;
          margin: 0 0 12px;
          text-align: justify;
        }

        .hx-brand p {
          font-size: 14px;
          line-height: 1.7;
          color: #555;
          text-align: justify;
          margin: 0 0 18px;
        }

        /* SOCIAL */
        .hx-social {
          display: flex;
          gap: 12px;
        }

        .hx-social a {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          border: 1.6px solid #1e2330;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #1e2330;
          font-size: 14px;
          transition: all 0.25s ease;
        }

        .hx-social a:hover {
          background: #c62828;
          border-color: #c62828;
          color: #fff;
          transform: translateY(-2px);
        }

        /* COLUMNS */
        .hx-footer-col h4 {
          font-size: 14.5px;
          letter-spacing: 1.6px;
          text-transform: uppercase;
          margin: 0 0 14px;
          text-align: justify;
          margin-left: 60px;
          font-weight: 800;
        }

        .hx-footer-col a {
          display: block;
          font-size: 15px;
          color: #555;
          text-decoration: none;
          margin-bottom: 9px;
          line-height: 1.4;
          text-align: justify;
          margin-left: 60px;

        }

        .hx-footer-col a:hover {
          color: #c62828;
        }

        /* ================= LOCATIONS ================= */
        .hx-locations {
          max-width: 1200px;
          margin: 0 auto;
          padding: 32px 20px;
          border-top: 1px solid #eee;
          display: grid;
          grid-template-columns: repeat(5, 1fr);
          gap: 20px;
          text-align: center; /* 🔑 FIX */
        }

        .hx-location h5 {
          margin: 0 0 6px;
          font-size: 14px;
          font-weight: 700;
          letter-spacing: 1px;
        }

        .hx-location p {
          margin: 0;
          font-size: 13px;
          color: #666;
        }

        /* ================= BOTTOM ================= */
        .hx-footer-bottom {
          background: #04031d;
          color:#fff;
          padding: 14px 20px;
        }

        .hx-footer-bottom-inner {
          max-width: 1200px;
          margin: 0 auto;
          display: flex;
          justify-content: space-between;
          align-items: center;
          font-size: 12.5px;
          margin-left: 600px;
        }

        .hx-footer-links a {
          margin-left: 16px;
          color: #555;
          text-decoration: none;
        }

        .hx-footer-links a:hover {
          color: #c62828;
        }

        /* ================= RESPONSIVE ================= */
        @media (max-width: 900px) {
          .hx-footer-top {
            grid-template-columns: 1fr 1fr;
          }
          .hx-locations {
            grid-template-columns: 1fr 1fr;
          }
        }

        @media (max-width: 540px) {
          .hx-footer-top {
            grid-template-columns: 1fr;
          }
          .hx-locations {
            grid-template-columns: 1fr;
          }
          .hx-footer-bottom-inner {
            flex-direction: column;
            gap: 8px;
          }
        }
      `}</style>

      {/* TOP */}
      <div className="hx-footer-top">
        <div className="hx-brand">
          <h2>Humanex</h2>
          <p>
            Humanex is a modern HR and workforce management the platform is helping
            organizations streamline hiring, onboarding, payroll, and people
            operations at scale.
          </p>

          <div className="hx-social">
            <a href="https://www.facebook.com/profile.php?id=61579126233218"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
      </svg></a>
            <a href="https://www.instagram.com/devopstrio_offcl/"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
      </svg></a>
            <a href="https://www.linkedin.com/company/devopstrio/"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
      </svg></a>
            <a href="https://youtube.com/@devopstrio"> <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
      </svg></a>
          </div>
        </div>

        <div className="hx-footer-col">
          <h4>Solutions</h4>
          <a href="/requirement-platform">Recruitment</a>
          <a href="/onboarding">Onboarding</a>
          {/* <a href="/performance-management">Performance</a> */}
          <a href="/time-attendance">Time & Attendance</a>
          {/* <a href="/hranalytics">People Analytics</a> */}
          <a href="/contact">FAQ</a>
        </div>

        <div className="hx-footer-col">
          <h4>Platform</h4>
          <a href="/access-recruit">Hiring</a>
          <a href="/hr-login">HR Portal</a>
          <a href="/employeelogin">Employees</a>
          <a href="/managerlogin">Managers</a>
          
        </div>

        <div className="hx-footer-col">
          <h4>Resources</h4>
          <a href="/benefits-admin">Benefits Admin</a>
          <a href="/reports">Reports & Insights</a>
          <a href="/compliance">Complaince</a>
          <a href="/training-development">Training</a>
        </div>

        <div className="hx-footer-col">
          <h4>Company</h4>
          <a href="/security">Security</a>
          <a href="/community">Community</a>
          <a href="/privacy">Privacy Policy</a>
          <a href="/terms-service">Terms of Service</a>
          {/* <a href="/aboutpage">Why Humanex</a> */}
        </div>
      </div>

      {/* LOCATIONS */}
      {/* <div className="hx-locations">
        <div className="hx-location">
          <h5>LONDON</h5>
          <p>United Kingdom</p>
        </div>
        <div className="hx-location">
          <h5>BANGALORE</h5>
          <p>India</p>
        </div>
        <div className="hx-location">
          <h5>CHENNAI</h5>
          <p>India</p>
        </div>
        <div className="hx-location">
          <h5>PASUVANTHANAI</h5>
          <p>India</p>
        </div>
        <div className="hx-location">
          <h5>NEW YORK</h5>
          <p>United States</p>
        </div>
      </div> */}

      {/* BOTTOM */}
      <div className="hx-footer-bottom">
        <div className="hx-footer-bottom-inner">
          <span>© 2026 Humanex. All rights reserved.</span>
        </div>
      </div>
    </footer>
  );
};

export default FooterSection;
